import LoginMerchant from './login-merchant';

export default LoginMerchant;
